import { ReadonlyRecord } from '@bimser/core';
import { Record, List } from 'immutable';

export interface IBaseEventArgs {
	handled?: boolean | Promise<{}>;
}

export interface IEventArgs extends IBaseEventArgs {}

export interface IReadonlyBaseEventArgs extends IBaseEventArgs {}

export type EventArgs = ReadonlyRecord<IReadonlyBaseEventArgs>;

export const EventArgsFactory = Record<IReadonlyBaseEventArgs>({
	handled: false
});

export const EventArgsFactoryFromJS = function (data: IEventArgs) {
	return EventArgsFactory({
		handled: data.handled
	});
};
